<template>
  <div class="weatherSummary">
    <div class="publishTime">{{ publishTime }}</div>
    <div class="publishContent">{{ content }}</div>
  </div>
</template>

<script>
import { home } from '../../api/index'
export default {
  created () {
    home.getGZ_analysisAndNews().then(data => {
      // 拼接时间字符串
      const timeGroup = data.AnalysisList[0].pdatetime.split(' ')
      const year = timeGroup[0].slice(0, 4)
      const month = timeGroup[0].slice(5, 7)
      const date = timeGroup[0].slice(8, 10)
      this.time = year + '年' + month + '月' + date + '日' + timeGroup[1].slice(0, 2)

      // 获取发布内容
      this.content = data.AnalysisList[0].description
    })
  },
  data () {
    return {
      // 发布时间
      time: '',

      // 发布内容
      content: ''
    }
  },
  computed: {
    publishTime () {
      return '广州市气象台' + this.time + '时 发布'
    }
  }
}
</script>

<style lang="less" scoped>
.weatherSummary {
  display: flex;
  flex-direction: column;
  .publishTime {
    align-self: flex-end;
  }
}
</style>
